import type { useDashboardStatisticsQuery } from '@queries'

import type { ShopStage } from './types'

export const getProfit = (
  data: ReturnType<typeof useDashboardStatisticsQuery>['dashboardStatisticsQuery']['data'],
) => {
  if (!data) return

  return data.status === 'DASHBOARD_STATISTICS' ? data.profit.amount.value : 0
}

export const getShopStageObject = (
  profit: number | undefined,
  orders: number | undefined,
): ShopStage => {
  if (profit == undefined || orders == undefined) {
    return { currentStage: undefined, stage1: false, stage2: false, stage3: false, stage4: false }
  }

  const stage1 = true
  const stage2 = stage1 && orders >= 3
  const stage3 = stage2 && profit >= 100
  const stage4 = stage3 && profit >= 1_000

  const currentStage = ((): ShopStage['currentStage'] => {
    if (stage4) return '4'
    if (stage3) return '3'
    if (stage2) return '2'
    if (stage1) return '1'

    return undefined
  })()

  return { currentStage, stage1, stage2, stage3, stage4 }
}
